import React from 'react';
import PropTypes from 'prop-types';

const labelStyle = {
  color: '#9a9a9a',
  textAlign: 'left',
  bottom: 25,
  position: 'absolute'
};

const BlockLabel = props => {
  const { label } = props;
  return (
    <h4 style={labelStyle}>{label}</h4>
  );
};

BlockLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default BlockLabel;



// WEBPACK FOOTER //
// ./src/containers/summary/components/block-label.js